import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=39a03380"
import script from "./Quotes.vue?vue&type=script&lang=ts"
export * from "./Quotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports